<template>
  <Popup header="Vorschau des Templates">
    <template v-slot:content>
      <v-row>
        <v-col>
          <FragebogenModule
            :fragebogenIdentifier="templateVorschau"
            :vorschau="true"
            :fragebogenVorherGeladen="true"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:action>
      <v-row>
        <v-col>&nbsp;</v-col>
        <v-col>
          <slot name="abort-btn">
            <b-btn class="mr-2" color="grey" @click="closePopup" block>
              <slot name="abort-btn-label">Schließen</slot>
            </b-btn>
          </slot>
        </v-col>
      </v-row>
    </template>
  </Popup>
</template>

<script>
import Popup from '@/components/base_components/Popup';
import FragebogenModule from '@/views/fragebogen/FragebogenModule';

export default {
  name: 'TemplateVorschauPopup',
  components: { Popup, FragebogenModule },
  props: {
    templateVorschau: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {

    };
  },
  computed: {},
  methods: {
    closePopup() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
